// LoadingState — 1:1 port of legacy `src/ui/LoadingState.jsx`.
// The `@keyframes magimp-spin` <style> block is preserved verbatim so the
// rotating loader icon keeps the identical animation.
import { Icon } from './Icon.js';
import { useTranslation } from 'react-i18next';

export interface LoadingStateProps {
  text?: string;
}

export function LoadingState({ text }: LoadingStateProps) {
  const { t } = useTranslation('common');
  const resolvedText = text ?? t('states.loading');
  return (
    <div style={{ padding: '48px 24px', textAlign: 'center', color: 'var(--fg-2)' }}>
      <div
        className="num"
        style={{
          marginBottom: 10,
          color: 'var(--accent-1)',
          display: 'inline-flex',
          animation: 'magimp-spin 1.2s linear infinite',
        }}
      >
        <Icon name="loader" size={22} />
      </div>
      <div style={{ fontSize: 13 }}>{resolvedText}</div>
      <style>{`@keyframes magimp-spin { from { transform: rotate(0) } to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}
